export default __webpack_public_path__ + "static/media/clear.1d3dae29.svg";